import { useEffect, useRef } from 'react';

import { FieldWrapperPassThroughProps } from './FieldWrapper';

declare let google: any;

type LocationInputFieldProps = FieldWrapperPassThroughProps & {
  className?: string;
  id?: string;
  value?: string;
  onChange?: (place: any) => void;
  onTextChange?: (place: any) => void;
  placeholder?: string;
};

export const AddressAutocomplete = (props: LocationInputFieldProps) => {
  const { className, id, value, onChange, placeholder, onTextChange } = props;
  const inputRef = useRef(null);
  let autoComplete: any = null;

  const getDetails = () => {
    if (!autoComplete) return;

    const place = autoComplete.getPlace();

    if (!place) return;

    const el: any = inputRef.current;
    let streetNumber='', route='', city='', state='', zipCode='', aptNumber='';
    if (place.address_components) {
      place.address_components.forEach((component: any) => {
        if (component.types.includes('street_number')) {
          streetNumber = component.long_name;
        } else if (component.types.includes('route')) {
          route = component.long_name;
        } else if (component.types.includes('locality')) {
          city = component.long_name;
        } else if (component.types.includes('administrative_area_level_1')) {
          state = component.short_name;
        } else if (component.types.includes('postal_code')) {
          zipCode = component.long_name;
        } else if (component.types.includes('subpremise')) {
          aptNumber = component.long_name;
        }
      });
    }

    el.value = `${streetNumber?streetNumber:place.name} ${route}`;

    if (typeof onChange !== 'function') return;

    const op: { [key: string]: any } = {
      name: place.name,
      icon: place.icon,
      address: place.formatted_address,
      url: place.url,
      phone: place.formatted_phone_number,
      website: place.website,
      opening_hours: place.opening_hours,
      place_id: place.place_id,
      lat: place?.geometry?.location?.lat(),
      lng: place?.geometry?.location?.lng(),
      streetNumber,
      route,
      city,
      state,
      zipCode,
      aptNumber,
    };
    onChange({ target: { id, value: op } });
  };

  useEffect(() => {
    const options = {
      types: ["geocode"]
    };

    if (inputRef && inputRef.current && google && google.maps && google.maps.places) {
      autoComplete = new google.maps.places.Autocomplete(inputRef.current, options);
      google.maps.event.addListener(autoComplete, 'place_changed', getDetails);
    }
  }, []);

  return (
    <input
      ref={inputRef}
      type="text"
      className={className}
      id={id}
      onChange={onTextChange}
      defaultValue={value}
      placeholder={placeholder}
    />
  );
};
